module.exports = __webpack_public_path__ + "img/kt-zl.ed54e80b.png";